import { MerchantWalletBalanceRequest, Wallets } from "../../../models/FinancialData";
import { BankTransferInitiateRequestModel, BankTransferInitiateResultModel, BankTransferRequestModel, BankTransferResultModel, CalculateMoneyTransferChargeRequest, MoneyTransferChargeResponse, PointToPointMoneyTransferRequestModel, WithdrawToAnyIBANMoneyTransferRequest } from "../../../models/MoneyTransferModal";
import { SourceOfFundsUploadRequest } from "../../../models/Orchestrator";
import { Result } from "../../../models/Result";
import { TransactionRequestModel } from "../../../models/Transactions";
import { httpService } from "../../HttpService";

class MoneyTransferApiService {
    path: string = "MoneyTransfers";

    moneyTransferInititate = async (model: BankTransferInitiateRequestModel): Promise<Result<BankTransferInitiateResultModel>> =>
      await httpService.post<BankTransferInitiateResultModel>(`/${this.path}/outgoing-transaction-initiate`, model);

    moneyTransferExecute = async (model: BankTransferRequestModel): Promise<Result<BankTransferResultModel>> =>
        await httpService.post<BankTransferResultModel>(`/${this.path}/outgoing-transaction-execute`, model);

    uploadSourceOfFunds = async (model: SourceOfFundsUploadRequest): Promise<Result<BankTransferResultModel>> =>
        await httpService.post<BankTransferResultModel>(`/${this.path}/upload-source-of-funds`, model);

    notifySourceOfFundsUploaded = async (model: BankTransferRequestModel): Promise<Result<BankTransferResultModel>> =>
        await httpService.post<BankTransferResultModel>(`/${this.path}/notify-all-source-of-funds-uploaded`, model);
  
  }

const moneyTransferApiService = new MoneyTransferApiService();

export { moneyTransferApiService };